import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import { useContactDetailsConfig } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { ConfigContentProps as Props } from './types';

export const ConfigContent = memo(({ className, limitedItems, sx }: Props) => {
  const { config, refs, activeTab, showFullItems } = useContactDetailsConfig();
  const itemsLimit = limitedItems && !showFullItems ? 2 : undefined;
  const activeTabData = config[activeTab];

  return (
    <Styled.Wrapper
      className={classnames('ConfigContent', className)}
      sx={mergeSx(SX.root, sx)}
    >
      <Stack gap={1}>
        <div
          key={activeTab.toString()}
          ref={refs[activeTabData.refName as keyof typeof refs]}
          style={{
            padding: 0,
          }}
        >
          <activeTabData.component.type
            {...activeTabData.component.props}
            itemsLimit={itemsLimit}
          />
        </div>
      </Stack>
    </Styled.Wrapper>
  );
});

ConfigContent.displayName = 'ConfigContent';
